<dln-button class="cancel-button" [label]="'Cancel'"
            (onClick)="cancelClick()" [color]="'gray'"></dln-button>

<dln-button [label]="sendLabel" (onClick)="sendClick()"
            [isLoading]="isLoading" [isLoadingLabel]="isLoadingLabel"
            [isDisabled]="!isValid" [color]="sendClass">
</dln-button>
